import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, ViewChildren, OnChanges, OnDestroy, SimpleChanges, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ComponentType, FormStatusEnum, FormType } from 'src/app/common/enumerations/enumerations';
import { ActionItem } from 'src/app/common/models/action-item';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { WFSectionLocalResource, WfSignatureResource } from 'src/app/components/workflow/workflow';
import { AbsiResource } from '../../absi';
import { AbsiSectionXComponent } from './absi-section-x/absi-section-x.component';

@Component({
  selector: 'absi-section-wrapper',
  templateUrl: './absi-section-wrapper.component.html',
  styleUrls: ['./absi-section-wrapper.component.scss']
})
export class AbsiSectionWrapperComponent implements OnInit, OnChanges, OnDestroy {

  @Input() section?: WFSectionLocalResource;
  @Input() absi?: AbsiResource | null;

  @Output() requestRefresh = new EventEmitter<any>();

  @ViewChild('section') private sectionComponent!: AbsiSectionXComponent;

  sections?: WFSectionLocalResource[];
  sections$!: Observable<WFSectionLocalResource[]>;
  sectionsSubs!: Subscription;

  actionItems$!: Observable<ActionItem[]>;
  actionItemsSubs!: Subscription;
  actionItems!: ActionItem[];

  date?: Date | null;
  user?: User | null = new User();
  catl!: number;

  formType = FormType.ABSI;
  sectionLoading = false;
  isLoading?: boolean;
  private expansionKey?: string;
  panelExpanded = false;

  statuses?: FormStatusEnum[] = [];

  @ViewChildren('panel', { read: ElementRef }) panels: any;

  constructor(
    private store: Store
  ) {

  }

  ngOnInit(): void {

  }

  /**
   * Releases section and action-item subscriptions when the wrapper is removed.
   */
  ngOnDestroy(): void {
    this.sectionsSubs?.unsubscribe();
    this.actionItemsSubs?.unsubscribe();
  }

  /**
   * Resets the panel only when a different ABSI section is selected, preserving manual expansion across refreshes.
   * @param changes Angular input changes for the wrapper.
   */
  ngOnChanges(changes: SimpleChanges) {
    // this.setLoading(true);;
    this.sectionLoading = false;
    const currentExpansionKey = `${this.absi?.id ?? 'new'}:${this.section?.id ?? ''}`;
    if (currentExpansionKey !== this.expansionKey) {
      this.expansionKey = currentExpansionKey;
      this.panelExpanded = false;
      // Start each newly selected ABSI section collapsed and let the user expand it manually.
      if (this.section) {
        this.section.collapsed = true;
      }
    }
    this.getSection();
  }

  /**
   * Keeps the local panel state and section model synchronized with manual expansion changes.
   * @param expanded Whether the panel is currently expanded.
   */
  panelOpen(expanded: boolean) {
    this.panelExpanded = expanded;
    if (this.section) {
      this.section.collapsed = !expanded;
    }
  }

  /**
   * Refreshes action items for the current section without retaining stale subscriptions.
   */
  getActionItems() {
    this.actionItemsSubs?.unsubscribe();
    this.actionItems$ = this.store.select(state => state.ActionItems.data);
    this.actionItemsSubs = this.actionItems$.subscribe(async data => {
      this.actionItems = data.filter(x => x.wfSectionId == this.section?.id);
      if (this.section?.wfSignatures) {
        const wfSignature = this.section.wfSignatures?.find(x => x.type == ComponentType.ButtonSignature);
        if (wfSignature) this.showInfo(wfSignature);
      }
    });
  }

  /**
   * Synchronizes the displayed section with the latest store data while retaining its local expansion state.
   */
  getSection() {
    if (this.section) {
      this.sectionsSubs?.unsubscribe();
      this.sections$ = this.store.select(state => state.AbsiSections.data);
      this.sectionsSubs = this.sections$.subscribe((data: WFSectionLocalResource[]) => {
        const sectionInfo = data.find(x => x.id == this.section?.id && x.wfTableID == this.absi?.wfTableID);
        if (sectionInfo) {
          sectionInfo.collapsed = this.section?.collapsed ?? true;
          this.section = sectionInfo;
          this.statuses = (this.section?.wfSignatures?.[0]?.wfTaskLocal.wfStepLocal?.wfStepStatusLocals?.map(s => s.status) ?? []) as FormStatusEnum[];
          this.getActionItems();
        }
      });
    }
  }

  create() {
    this.sectionComponent.create();
  }

  showInfo(wfSignature: WfSignatureResource) {
    this.user = wfSignature.signedBy;
    this.date = wfSignature.signedOn;
    this.catl = this.actionItems?.length;
  }

  setLoading(value: boolean) {
    setTimeout(() => {
      this.isLoading = value;
      //this.loading.emit(value);
    }, 100);
  }

}
